import { render, staticRenderFns } from "./BarOrderPage.vue?vue&type=template&id=20f20164&scoped=true"
import script from "./BarOrderPage.vue?vue&type=script&lang=js"
export * from "./BarOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f20164",
  null
  
)

export default component.exports